import type { LegalInfoProps } from '@/features/enrollment'

export default function LegalInfo({ enrollmentData, updateEnrollmentData, errors }: LegalInfoProps) {
  // Detect if this is a roblox campaign
  const isRobloxCampaign =
    enrollmentData.campaignId === 'roblox-exploitation' ||
    enrollmentData.selectedCampaign === 'robloxExploitation' ||
    enrollmentData.campaign?.name?.toLowerCase().includes('roblox')

  return (
    <>
      {/* Attorney Representation */}
      <div>
        <label className="block text-sm font-medium text-accent-700 mb-2">
          Have you previously signed documents with an attorney for this claim? <span className="text-red-500">*</span>
        </label>
        <div className="flex items-center space-x-4">
          <label className="flex items-center">
            <input type="radio" name="hasAttorneyRepresentation" value="true" checked={enrollmentData.hasAttorneyRepresentation === true} onChange={() => updateEnrollmentData('hasAttorneyRepresentation', true)} className="form-radio text-primary-600" />
            <span className="ml-2 text-accent-700">Yes</span>
          </label>
          <label className="flex items-center">
            <input type="radio" name="hasAttorneyRepresentation" value="false" checked={enrollmentData.hasAttorneyRepresentation === false} onChange={() => updateEnrollmentData('hasAttorneyRepresentation', false)} className="form-radio text-primary-600" />
            <span className="ml-2 text-accent-700">No</span>
          </label>
        </div>
        
        {/* Warning when Yes is selected - different message for roblox vs other campaigns */}
        {enrollmentData.hasAttorneyRepresentation === true && (
          <div className="mt-2">
            {isRobloxCampaign ? (
              <p className="text-sm text-red-600 font-medium">⚠️ Warning: This client will be disqualified from enrollment</p>
            ) : (
              <p className="text-sm text-red-600 font-medium">⚠️ Warning: This client may be disqualified from enrollment</p>
            )}
          </div>
        )}
        
        <p className="text-xs text-accent-500 mt-1">
          {isRobloxCampaign 
            ? 'Note: Selecting "Yes" will disqualify the client and prevent continue'
            : 'Note: Selecting "Yes" may disqualify the client'
          }
        </p>
        {errors.hasAttorneyRepresentation && (
          <p className="mt-1 text-sm text-red-600">{errors.hasAttorneyRepresentation}</p>
        )}
      </div>
    </>
  )
}
